//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import FfBreadcbItem from "@/pccomponents/FfBreadcbItem";
  import {loadUam} from "@/utils/pagelog.js";
  
  export default {
    name: 'FfBreadcb',

    data() {
      return {
        itemList: [],
        vcurrmoduid : "",
        // js埋点
				uam_xy_paq: [],
				breadcbOffset: 0,
				showFlag: false
      }
    },

    components: {
      FfBreadcbItem
    },

    props: {
      // 当前菜单ID
      currpathid:  {
        type: String,
        default: ""
      },
      // 当前模块ID
      currmoduid:  {
        type: String,
        default: ""
      },
      
      // 分隔符
      separator: {
        type: String,
        default: "/"
      },
      // 分隔符样式
      separatorClass: {
        type: String,
        default: ""
      },
      // 流程信息
      process: {type: Object},
    },

    provide() {
      return {
        elBreadcrumb: this
      };
    },

    methods: {
      // 初始化埋点信息
      initBuryingPoint() {
        //  根据必填项判断是否要设置埋点
        let sNotNullItems = "";
        if (this.process) {
          sNotNullItems = this.process.notnullitems;
        }
        if (sNotNullItems !== undefined && sNotNullItems !== '' && sNotNullItems !== null) {
            if (sNotNullItems.indexOf(';SETBURYINGPOINT|') !== -1) {
              console.log("进入埋点。。。");
              this.uam_xy_paq.push(['server_url', process.env.API_ROOT_DISPATCH + 'sendkafka/sendqueue']);
              this.uam_xy_paq.push(['systemCode', this.process.flow_gsysid]);
              this.uam_xy_paq.push(['moduleCode', this.process.flow_btype]);
              this.uam_xy_paq.push(['menuId', this.currpathid]);
              this.uam_xy_paq.push(['virtualOrderId', this.process.flow_keyval]);
              this.uam_xy_paq.push(['setLoginName', this.process.flow_guserid]);
              this.uam_xy_paq.push(['areaCode', this.process.flow_gareacode]);
              this.uam_xy_paq.push(['staffId', this.process.flow_guserid]);
              this.uam_xy_paq.push(['custOrderNbr', this.process.flow_keyval]);
              this.uam_xy_paq.push(['channelNbr', this.process.flow_keyval]);
              this.uam_xy_paq.push(['custId', this.process.flow_guserid]);
              this.uam_xy_paq.push(['custCertNbr', this.process.flow_guserid]);
              this.uam_xy_paq.push(['custCertType', '']);
              loadUam(this);
            }
        }
			},
			toggleShow() {
				let _display = this.$refs.breadcbPopover.style.display;
				if(_display != "none") {
					this.$refs.breadcbPopover.style.display = "none";
				} else {
					this.$refs.breadcbPopover.style.display = "block";
				}
			},
			getShowFlag() {
				let _this = this;
				let timer = setTimeout(() => {

					let layoutDiv = _this.$refs.layoutDiv;
					if(layoutDiv) {
						let breadcbItems = layoutDiv.querySelectorAll(".el-breadcrumb__item");
						let widthSum = 0;
						for(let i=0; i<breadcbItems.length; i++) {
							widthSum += breadcbItems[i].offsetWidth;
							if(widthSum >= _this.$el.offsetWidth) {
								_this.showFlag = true;
								setBreadcbPopoverPos();
								break;
							}
						}
					}

					// 设置位置
					function setBreadcbPopoverPos() {
						let breadcrumb_domRect = _this.$el.getBoundingClientRect();
						let breadcrumb_left = breadcrumb_domRect.left;
						let breadcrumb_top = breadcrumb_domRect.top;
						let breadcrumb_height = breadcrumb_domRect.height;

						_this.$refs.breadcbPopover.style.top = breadcrumb_top + breadcrumb_height + 1 + "px";
						_this.$refs.breadcbPopover.style.left = breadcrumb_left + "px";
					}

					clearTimeout(timer);
				}); 
			}
		},

    watch: {
        currmoduid:{
            handler:function(val){
                if(val != null && val != undefined && val != ""){
                    let url = "/menu/getParentmenu";
                    let showAllPathFlag = "1"; // 如果没有流程帧，则显示全部路径，否则只显示当前路径
                    if (this.process != null) {
                      showAllPathFlag = "0";
                    }
                    let params = {
                        "currmoduid": val,
                        "showallpathflag": showAllPathFlag,
                    };
                    this.axios.post(url, params).then(({data}) => {
                        this.itemList = data.data.menuList;
                        this.$nextTick(function() {
                            this.getShowFlag();
                        })
                    }); 
                }
            },
        },
        currpathid:{
            handler:function(val){
              
                if(val == undefined || val == null || val == "") {
                    val = this.$route.query.pd;
                }
                if(val == undefined || val == null || val == "") {
                    val = 100;
                }
                if(val != null && val != undefined && val != ""){
                    let url = "/menu/getParentmenu";
                    if (val == "") {
                        val = this.$route.query.pd;
                    }
                    let showAllPathFlag = "1"; // 如果没有流程帧，则显示全部路径，否则只显示当前路径
                    if (this.process != null) {
                      showAllPathFlag = "0";
                    }
                    let params = {
                        "currpathid": val,
                        "showallpathflag": showAllPathFlag,
                    };
                    this.axios.post(url, params).then(({data}) => {
                        this.itemList = data.data.menuList;
                        this.$nextTick(function() {
                            this.getShowFlag();
                        })
                    }); 
                }
            },
            immediate: true
        }
    },

    beforeCreate() {
      console.log("===================beforeCreate=================");
    },
    created() { 
      console.log("===================created=================");
    },
    beforeMount() {
      console.log("===================beforeMount=================");
    },
    mounted() {
      const items = this.$el.querySelectorAll('.el-breadcrumb__item');
      if (items.length) {
        items[items.length - 1].setAttribute('aria-current', 'page');
			}

    },
    beforeUpdate() {
      console.log("===================beforeUpdate=================");
    },
    updated() {
			this.initBuryingPoint();
			this.getShowFlag();
      console.log("===================updated=================");
    },
    beforeDestroy() {
      console.log("===================beforeDestroy=================");
    },
    destroyed() {
      console.log("===================destroyed=================");
    },
  };



// WEBPACK FOOTER //
// ./src/pccomponents/FfBreadcb.vue